export const generateImageName = (trackingNumber, imageType) => {
  return `${Date.now()}-${trackingNumber}.${imageType}`
}